import { jsx as _jsx } from "react/jsx-runtime";
import { formatPrice } from '@cronos-app/utils';
import { forwardRef, useMemo } from 'react';
import { BasicNumber } from './BasicNumber';
export const Quantity = forwardRef(({ value: _value, format, ...props }, ref) => {
    const value = useMemo(() => _value ? formatPrice(Number(_value), { min: 0, ...format }) : undefined, [_value, format]);
    return _jsx(BasicNumber, { ...props, value: value, ref: ref });
});
Quantity.displayName = 'Quantity';
